/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

export const WrcColors = {
    PRIMARY_L1:     "#6A8AB6",
    PRIMARY_L2:     "#43689A",
    PRIMARY:        "#2B538B",
    PRIMARY_D3:     "#193F73",
    PRIMARY_D4:     "#092B5A",

    SECONDARY_L1:   "#61B3A1",
    SECONDARY_L2:   "#3A9782",
    SECONDARY:      "#218871",
    SECONDARY_D3:   "#10715B",
    SECONDARY_D4:   "#015845",

    TERNARY_L1:     "#7C72BE",
    TERNARY_L2:     "#574BA3",
    TERNARY:        "#3F3292",
    TERNARY_D3:     "#2B1E79",
    TERNARY_D4:     "#190D5F",

    BRANDING_ROTATION: ["#6A8AB6", "#7C72BE", "#61B3A1"],

    CHART_COLORS:    ["#2965CC", "#D99E0B", "#29A634", "#D13913", "#8F398F", "#00B3A4", "#DB2C6F", "#9BBF30", "#96622D", "#7157D9"],
    CHART_COLORS_L1: ["#4580E6", "#F2B824", "#43BF4D", "#EB532D", "#A854A8", "#14CCBD", "#F5498B", "#B6D94C", "#B07B46", "#9179F2"],
    CHART_COLORS_L2: ["#669EFF", "#FFC940", "#62D96B", "#FF6E4A", "#C274C2", "#2EE6D6", "#FF66A1", "#D1F26D", "#C99765", "#AD99FF"],
};
